import { useToasts } from 'react-toast-notifications';
import { useQuery } from '@apollo/react-hooks';

import { VIEWER_INVESTMENTS_QUERY } from './queries';

const useViewerInvestments = () => {
  const { addToast } = useToasts();

  const { data: { viewer: { investments = [] } = {} } = {}, loading, error } = useQuery(VIEWER_INVESTMENTS_QUERY, {
    onError: (err) => {
      console.log(err);
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach((e) => {
          if (
            (e.message.includes('You do not have access to this resource') || e.name === 'AccessDeniedError')
            && e.path.length === 0
            && (e.path[0] === 'viewer' || e.path[0] === 'authenticatedCustomer')
          ) {
            addToast('You are not signed in', {
              appearance: 'error',
              autoDismiss: true,
              autoDismissTimeout: 10000,
            });
          }
        });
      } else {
        addToast('Something unexpected happened, Try Again later', {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    },
  });

  return {
    investments,
    error,
    loading,
  };
};

export default useViewerInvestments;
